<template>
    <div>
        <panel Title="تنظیمات سایت" :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
        <div class="row px-3">
      <div class="col-12 col-md-12 mx-md-2 p-md-3">

        <nav>
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a class="nav-item nav-link text-dark active" id="nav-home-tab" data-toggle="tab" 
            href="#webSiteSetting" role="tab" aria-controls="webSiteSetting" aria-selected="true">درباره ما</a>
          </div>
        </nav>

        <div class="tab-content" id="nav-tabContent">
          <div class="tab-pane fade show active" id="webSiteSetting" role="tabpanel" aria-labelledby="nav-home-tab">
            <net-pa-card>
              <template slot="header">
                <h6 class="text-right"><i class="fas fa-list-alt mx-2"></i>تنظیمات درباره ما</h6>
              </template>
              <template slot="content">
                <AboutUs/>
              </template>
            </net-pa-card>
          </div>
        </div>
      </div>
    </div>
    </div>
</template>


<script>
import Panel from '../Tools/NetPa/Panel.vue'
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import AboutUs from './Manage/AboutUs/ManageAboutUs.vue'
export default {
    components: { Panel, NetPaCard, AboutUs },
    data() {
        return{

        }
    },
}

</script>


<style scoped>

</style>